import styled from '@emotion/styled'
import { colors } from 'parameters/ui'
import { mediaQueriesByDevice } from 'parameters/viewport'

const MARGIN_RIGHT = 24

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`
export const ArticlesWrapper = styled.div`
	width: 100%;
	${mediaQueriesByDevice.mobilePortrait} {
		width: calc(100vw - 88px); // 88px equals to horizontal paddings of containers
		margin: 0 auto;
		display: flex;
		min-height: 203px;
		overflow-x: auto;
		scroll-snap-type: x mandatory;
		scroll-behavior: smooth;
		-webkit-overflow-scrolling: touch;

		&::-webkit-scrollbar {
			display: none;
		}

		> a {
			margin-right: ${MARGIN_RIGHT}px;
		}

		> a:last-of-type {
			margin-right: 0;
		}
	}
`
export const ArticlesMobileDots = styled.div`
	display: none;

	${mediaQueriesByDevice.mobilePortrait} {
		display: flex;
		margin: 16px auto 24px auto;
	}
`
export const Dot = styled.div<{ isActive: boolean }>`
	width: 12px;
	height: 12px;
	border-radius: 100%;
	background: ${({ isActive }) => (isActive ? colors.primaryPurple1 : colors.secondaryLightGrey1)};
	margin: 0 4px;
`
export const TitleWrapper = styled.div`
	display: flex;
`
export const Title = styled.p`
	font-weight: bold;
	font-size: 22px;
	line-height: 29px;
	margin-bottom: 24px;
	margin-left: 16px;
`
export const Bottom = styled.div`
	display: flex;
	flex-grow: 1;
	justify-content: flex-end;
	align-items: flex-end;

	${mediaQueriesByDevice.mobilePortrait} {
		justify-content: center;
	}
`
